import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SuggestedTitleFragmentDoc } from '../fragments/SuggestedTitle.fragment';
import { SuggestedPersonFragmentDoc } from '../fragments/SuggestedPerson.fragment';
export type GetSearchResultsQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	first: Types.Scalars['Int']['input'];
	searchQuery?: Types.InputMaybe<Types.Scalars['String']['input']>;
	location: Types.Scalars['String']['input'];
}>;

export type GetSearchResultsQuery = {
	__typename?: 'Query';
	searchTitles: {
		__typename?: 'TitleSearchResult';
		edges: Array<{
			__typename?: 'TitleSearchResultEdge';
			node:
				| {
						__typename: 'Movie';
						id: string;
						objectType: Types.ObjectType;
						objectId: number;
						content: {
							__typename?: 'MovieContent';
							fullPath: string;
							title: string;
							originalReleaseYear?: number | null;
							posterUrl?: string | null;
						};
						watchNowOffer?: {
							__typename?: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							package: { __typename?: 'Package'; id: string; packageId: number; shortName: string };
						} | null;
						offers: Array<{
							__typename?: 'Offer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							id: string;
							package: { __typename?: 'Package'; id: string; packageId: number; shortName: string };
						}>;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectType: Types.ObjectType;
						objectId: number;
						content: {
							__typename?: 'ShowContent';
							fullPath: string;
							title: string;
							originalReleaseYear?: number | null;
							posterUrl?: string | null;
						};
						watchNowOffer?: {
							__typename?: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							package: { __typename?: 'Package'; id: string; packageId: number; shortName: string };
						} | null;
						offers: Array<{
							__typename?: 'Offer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							id: string;
							package: { __typename?: 'Package'; id: string; packageId: number; shortName: string };
						}>;
				  };
		}>;
	};
	popularPeople: {
		__typename?: 'PopularPeopleConnection';
		edges?: Array<{
			__typename?: 'PopularPeopleEdge';
			node: {
				__typename?: 'Person';
				id: string;
				objectType: Types.ObjectType;
				objectId: number;
				content: {
					__typename?: 'PersonContent';
					fullName: string;
					dateOfBirth?: any | null;
					portraitUrl?: string | null;
				};
			};
		}> | null;
	};
};

export const GetSearchResultsDocument = gql`
	query GetSearchResults(
		$country: Country!
		$language: Language!
		$first: Int!
		$searchQuery: String
		$location: String!
	) {
		searchTitles(
			country: $country
			first: $first
			filter: { searchQuery: $searchQuery, includeTitlesWithoutUrl: true }
			source: $location
		) {
			edges {
				node {
					...SuggestedTitle
				}
			}
		}
		popularPeople(country: $country, first: $first, filter: { searchQuery: $searchQuery }) {
			edges {
				node {
					...SuggestedPerson
				}
			}
		}
	}
	${SuggestedTitleFragmentDoc}
	${SuggestedPersonFragmentDoc}
`;
